import sessionService from 'services/session.service';
import store from 'store/index';
import { logout, setTokens } from 'store/auth/auth';
import { redirectToLoginPage } from 'utils/generalUtils';
import httpClient from '../index';
import * as apiServices from 'services/index';

/* tslint:disable:no-let */
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token) => {
  failedQueue.forEach((promise) => {
    if (error) {
      promise.reject(error);
    } else {
      promise.resolve(token);
    }
  });

  failedQueue = [];
};

const retryWithToken = (originalRequest, token) => {
  originalRequest._retry = true;
  originalRequest.headers.Authorization = `Bearer ${token}`;
  return httpClient(originalRequest);
};

const logoutAndRedirect = async () => {
  await store.dispatch(logout());
  redirectToLoginPage();
};

export const sessionRecoveryInterceptor = {
  onFulFilled: (config) => config,
  onError: (error) => {
    const originalRequest = error?.config;
    const refreshToken = store.getState().auth.refreshToken; // get refresh token from react store
    if (originalRequest?.url.endsWith('/refresh')) {
      return Promise.reject(error);
    }

    if (error.response?.status === 400) {
      // do logout router.push({ name: 'logout' });
      return Promise.reject(error);
    }

    if (error.response?.status === 403) {
      store.dispatch(logout());
      return Promise.reject(error);
    }

    if (error.response?.status === 401) {
      // a request that already got a fresh token and still failed must not trigger another refresh
      if (originalRequest._retry) {
        return Promise.reject(error);
      }

      // the request was sent with a token that has since been replaced by a refresh - just retry it
      const currentToken = store.getState().auth.accessToken;
      if (
        !isRefreshing &&
        currentToken &&
        originalRequest.headers?.Authorization !== `Bearer ${currentToken}`
      ) {
        return retryWithToken(originalRequest, currentToken);
      }

      // Logic to prevent double requests to refreshToken endpoint
      // when we have multiple parallel requests that return 401.
      if (isRefreshing) {
        return new Promise(function (resolve, reject) {
          failedQueue.push({ resolve, reject });
        }).then((token) => retryWithToken(originalRequest, token));
      }

      isRefreshing = true;

      return new Promise(function (resolve, reject) {
        sessionService.refreshToken(refreshToken).then(
          ({ data }) => {
            // set tokenns on store
            store.dispatch(setTokens(data));

            //clearing received data for all APIs
            Object.values(apiServices).forEach((api) => {
              if (api.util?.resetApiState) {
                store.dispatch(api.util.resetApiState());
              }
            });

            processQueue(null, data.access_token);
            isRefreshing = false;
            resolve(retryWithToken(originalRequest, data.access_token));
          },
          (err) => {
            processQueue(err, null);
            isRefreshing = false;
            logoutAndRedirect();
            reject(err);
          },
        );
      });
    }

    return Promise.reject(error);
  },
};
